import { createFileRoute, redirect } from '@tanstack/react-router';

import { PortalBannerSettingsPage } from '~features/settings/portal-banner';

import { getCurrentUser } from '~entities/users/model/user-store';
import { isEnrollioStaffEmail } from '~shared/utils/is-enrollio-staff-email';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/_settings/portal-banner')({
  beforeLoad: () => {
    const currentUser = getCurrentUser();
    if (!isEnrollioStaffEmail(currentUser?.email)) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: PortalBannerSettingsPage,
});
